import { render, staticRenderFns } from "./newDesign.vue?vue&type=template&id=6616293e&scoped=true"
import script from "./newDesign.vue?vue&type=script&lang=js"
export * from "./newDesign.vue?vue&type=script&lang=js"
import style0 from "./newDesign.vue?vue&type=style&index=0&id=6616293e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6616293e",
  null
  
)

export default component.exports